exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nil-sa-elements-fontawesome__faContainer{display:block;width:1em;height:1em;position:relative;padding:0}.nil-sa-elements-fontawesome__faIcon{box-sizing:content-box;position:relative;display:inline!important;width:1em;height:1em}.nil-sa-elements-fontawesome__spin{position:absolute;-webkit-animation:nil-sa-elements-fontawesome__spin 2s linear infinite;-moz-animation:nil-sa-elements-fontawesome__spin 2s linear infinite;animation:nil-sa-elements-fontawesome__spin 2s linear infinite}@-moz-keyframes nil-sa-elements-fontawesome__spin{to{-moz-transform:rotate(1turn)}}@-webkit-keyframes nil-sa-elements-fontawesome__spin{to{-webkit-transform:rotate(1turn)}}@keyframes nil-sa-elements-fontawesome__spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);

// exports
exports.locals = {
	"faContainer": "nil-sa-elements-fontawesome__faContainer",
	"faIcon": "nil-sa-elements-fontawesome__faIcon",
	"spin": "nil-sa-elements-fontawesome__spin"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/elements/FontAwesome/index.less
// module id = 341
// module chunks = 0